<template>
  <label class="a-checkbox">
    <input
      v-model="checkedData"
      type="checkbox"
      class="a-checkbox__body"
      :value="dataValue"
      @change="changeCheckbox"
    />
    <span class="a-checkbox__icon" :class="errorClassName"></span>
    <slot />
  </label>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ACheckbox',
  props: {
    dataValue: {
      type: [String, Number, Boolean],
      required: true,
      default: ''
    },
    value: {
      type: [String, Number, Boolean],
      required: true,
      default: ''
    },
    error: {
      type: Boolean,
      required: false,
      default: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      checkedData: []
    };
  },
  computed: {
    errorClassName() {
      return this.error ? 'a-checkbox__icon--error' : '';
    }
  },
  created() {
    if (this.value) {
      this.checkedData.push(this.value);
    }
  },
  methods: {
    changeCheckbox() {
      if (this.required) {
        this.$emit('change', {
          value: this.checkedData,
          error: !this.checkedData.length
        });
      } else {
        this.$emit('change', {
          value: this.checkedData,
          error: false
        });
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.a-checkbox {
  display: flex;
  align-items: center;

  &__icon {
    position: relative;
    display: block;
    min-width: 28px;
    min-height: 28px;
    background: $gray-scale-color-31;
    border: 1px solid $gray-scale-color-31;
    border-radius: 4px;

    &::after {
      content: '';
      display: block;
    }

    &--error {
      border-color: $error-color;
    }
  }

  &__body {
    display: none;

    &:checked {
      + .a-checkbox__icon {
        &::after {
          content: '';
          position: absolute;
          top: 6px;
          left: 0;
          right: 0;
          display: block;
          width: 8px;
          height: 14px;
          margin: auto;
          border-bottom: 3px solid $main-color;
          border-right: 3px solid $main-color;
          transform: rotate(40deg);
        }
      }
    }
  }
}
</style>
